import React, { useState, useEffect } from 'react';

export const Slides = ({ imgs }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentImageIndex((prevIndex) => {
                if (prevIndex === imgs.length) {
                    return 0
                } else {
                    return prevIndex + 1
                }
            })
        }, 4000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="slides-container">
            <div className={currentImageIndex === 0 ? 'slides-frame last-img' : "slides-frame"} style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}>
                {imgs.map((image, index) => (
                        <img key={index} src={image} alt={`Slide ${index + 1}`} />
                ))}
                    <img src={imgs[0]} />
            </div>
        </div>
    );
};


